module.exports = __webpack_public_path__ + "img/samtik.df1e60be.png";